/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Table, Button, Form } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';

interface Props {
  open: boolean;
  setOpen: (v: boolean) => void;
  availableGroups: any[];
  setAvailableGroups: (v: any) => void;
  section: any;
}

const GroupManagerPanel: React.FC<Props> = ({
  open,
  setOpen,
  availableGroups,
  setAvailableGroups,
  section,
}) => {
  return (
    <div className={`slide-panel ${open ? 'open' : ''}`}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="m-0">Manage Groups</h5>
        <i
          role="button"
          onClick={() => setOpen(false)}
          className="bi bi-arrow-right-circle"
          style={{ fontSize: '1.5rem', cursor: 'pointer' }}
        ></i>
      </div>

      {availableGroups.length === 0 ? (
        <p>No groups added for this section.</p>
      ) : (
        <Table size="sm" className="table-transparent">
          <thead>
            <tr>
              <th style={{ width: '80%' }}>Title</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {availableGroups.map((g, idx) => (
              <tr key={g.id}>
                <td>
                  <Form.Control
                    value={g.title}
                    onChange={(e) => {
                      const updated = [...availableGroups];
                      updated[idx] = { ...updated[idx], title: e.target.value };
                      setAvailableGroups(updated);
                    }}
                  />
                </td>
                <td className="text-center">
                  <Button
                    size="sm"
                    variant="outline-danger"
                    className="editor-icon-button"
                    onClick={() =>
                      setAvailableGroups(
                        availableGroups.filter((_, i) => i !== idx)
                      )
                    }
                  >
                    ✕
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      <Button
        size="sm"
        variant="outline-primary"
        onClick={() =>
          setAvailableGroups([
            ...availableGroups,
            {
              id: uuidv4(),
              title: 'New Group',
              section_id: section.id,
              sort_order: availableGroups.length + 1,
              created_at: new Date().toISOString(),
              description: '',
            },
          ])
        }
      >
        + Add Group
      </Button>
    </div>
  );
};

export default GroupManagerPanel;
